import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { CommonUIComponent } from './components/common-ui/common-ui.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ForgotUsernameComponent } from './components/forgot-username/forgot-username.component';
import { ConfirmCodeComponent } from './components/login/confirm-code/confirm-code.component';
import { LoginMfaGuard } from './guards/login-mfa-guard.service';
import { NewPasswordRequiredComponent } from './components/login/new-password-required/new-password-required.component';
import { ForgotPasswordConfirmComponent } from './components/forgot-password/forgot-password-confirm.component';
import { LogoutConfirmComponent } from './components/logout/logout-confirm.component';
import { AuthGuard } from './guards/auth-guard.service';
import { NoAuthGuard } from './guards/no-auth-guard.service';
import { LoginNewPasswordRequiredGuard } from './guards/login-new-password-required-guard.service';
import { ForgotUsernameSuccessComponent } from './components/forgot-username/forgot-username-success.component';
import { ForgotUsernameGuard } from './guards/forgot-username-guard.service';
import { MxAccessResolver } from './resolvers/mx-access-resolver.service';
import { AdminResolver } from './resolvers/admin-resolver.service';
import { LoginPasswordExpiredGuard } from './guards/login-password-expired-guard.service';
import { PasswordExpiredComponent } from './components/login/password-expired/password-expired.component';
import { LogoutResolver } from './resolvers/logout-resolver.service';
import { LogoutComponent } from './components/logout/logout.component';
import { LoginMfaSelfRegistrationGuard } from './guards/login-mfa-self-registration-guard.service';
import { MfaSelfRegistrationComponent } from './components/login/mfa-self-registration/mfa-self-registration.component';
import { NetPromoterScoreComponent } from './components/npscore/net-promoter-score.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: CommonUIComponent,
    canActivate: [AuthGuard],
    resolve: { adminData: AdminResolver }
  },
  {
    path: 'mx-access',
    pathMatch: 'full',
    component: CommonUIComponent,
    canActivate: [AuthGuard],
    resolve: { navConfig: MxAccessResolver }
  },

  // login
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'new-password-required',
    component: NewPasswordRequiredComponent,
    canActivate: [LoginNewPasswordRequiredGuard]
  },
  {
    path: 'password-expired',
    component: PasswordExpiredComponent,
    canActivate: [LoginPasswordExpiredGuard]
  },
  {
    path: 'mfa-self-registration',
    component: MfaSelfRegistrationComponent,
    canActivate: [LoginMfaSelfRegistrationGuard]
  },
  {
    path: 'confirm-code-sms',
    component: ConfirmCodeComponent,
    canActivate: [LoginMfaGuard]
  },
  {
    path: 'confirm-code-totp',
    component: ConfirmCodeComponent,
    canActivate: [LoginMfaGuard]
  },

  {
    path: 'logout-confirm',
    component: LogoutConfirmComponent,
    canActivate: [AuthGuard]
  },
  // {path: 'logout-success', component: LogoutSuccessComponent, canActivate: [NoAuthGuard]},

  // forgot username
  {
    path: 'forgot-username',
    component: ForgotUsernameComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'forgot-username-success',
    component: ForgotUsernameSuccessComponent,
    canActivate: [ForgotUsernameGuard]
  },

  // forgot password
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'forgot-password-confirm',
    component: ForgotPasswordConfirmComponent,
    canActivate: [NoAuthGuard]
  },
  {
    path: 'npsscore',
    component: NetPromoterScoreComponent,
    canActivate: [NoAuthGuard]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
  providers: [AdminResolver]
})
export class AppRoutingModule {}

export const routedComponents = [CommonUIComponent];
